import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { CommonModule, NgIf, NgOptimizedImage } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { NgxTypedWriterModule } from 'ngx-typed-writer';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from 'src/environments/environment';

/** questo componente mostra una promo specifica per il playmetrics
 * viene mostrato dapprima un testo a comparsa stile scrittura AI e poi una animazione di uno schermo laptop che si apre e poi scivola di lato per far posto alla promo
 */
@Component({
  selector: 'promo-playmetrics',
  standalone: true,
  imports: [NgIf,
    MatCardModule,
    MatButtonModule,
    NgOptimizedImage,
    NgxTypedWriterModule,
    SharedModule
  ],
  templateUrl: './promo-playmetrics.component.html',
  styleUrls: ['./promo-playmetrics.component.scss'],
  animations: [
    trigger('fadeInLeft', [
      state('void', style({ opacity: 0, transform: 'translateX(-100px)' })),
      state('hidden', style({ opacity: 0, transform: 'translateX(-100px)' })),
      transition('void => *', [
        animate('500ms {{ delay }} ease-in', style({ opacity: 1, transform: 'translateX(0)' }))
      ], { params: { delay: '0ms' } })
    ]),
    trigger('pulse', [
      state('void', style({ opacity: 0 })),
      transition('void => *', [
        animate('500ms 500ms ease-in-out', keyframes([
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)', offset: 0 }),
          style({ opacity: 1, transform: 'scale3d(1, 1, 1)', offset: 0.3 }),
          style({ opacity: 0.6, transform: 'scale3d(0.7, 0.7, 0.7)', offset: 0.6 }),
          style({opacity:1, transform: 'scale3d(1, 1, 1)', offset: 1.0})
        ]))
      ])
    ]),
    trigger('moveRight', [
      state('void', style({ right:'auto', left:'auto' })),
      transition('void => *', [
        animate('700ms  500ms ease-in', style({ right:'0', left:'auto' }))
        
      ])
    ]),
    trigger('flipScreen', [
      state('void', style({ opacity:1, transform: 'perspective(1000px) rotateX(-90deg)',transformOrigin: 'bottom'})),
      transition('void => *', [
        animate('750ms 500ms ease-out',style({opacity:1,transform: 'perspective(1000px) rotateX(0deg)',transformOrigin: 'bottom'}))
      ])
    ])
   
  ]
})
export class PromoPlaymetricsComponent {
  isInView: boolean = false;
  showAction: boolean = false;
  showText: boolean = false;
  showPromo: boolean = false;
  moveLpatop: boolean = false;

  @Input() animate: boolean = true
  @Output() animationComplete = new EventEmitter();
  
  constructor(private router: Router) { 
   
  }
  goToPlaymetrics() {
    this.router.navigate([environment.routingBasePath + '/product/playmetrics']);
  }
  revealPromo(event: any) {
   
    setTimeout(() => {
      this.showPromo = true
    }, 700);
    
  }

  reveal(event: any) {
    if (event) {
      this.isInView = true
    }
  }
  revealText(event: any) {
    if (event) {
      this.showText = true
    }
  }

  revealAction(event?: any) {
    this.showAction = true;
    this.animationComplete.emit(true)
  }

  moveLaptop(event: any) {
    if (event) {
      this.moveLpatop = true
    }
  }

}
